import * as React from "react";
import type { SVGProps } from "react";
const SvgMobilePhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#mobile-phone_svg__a)">
      <path d="M16 22H8c-1.65 0-3-1.35-3-3V5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v14c0 1.65-1.35 3-3 3M8 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z" />
      <path d="M14 5h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M12 18c-.13 0-.26-.02-.38-.08-.13-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.1-.09.2-.16.33-.21a1 1 0 0 1 .76 0c.13.05.23.12.33.21.18.19.29.45.29.71s-.11.52-.29.71c-.1.09-.2.16-.33.21-.12.06-.25.08-.38.08" />
    </g>
    <defs>
      <clipPath id="mobile-phone_svg__a">
        <path fill="#fff" d="M5 2h14v20H5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMobilePhone;
